export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/files-icon.svg?28481aaacbd580bb4501f8040dcf607d";